import { useFormikContext } from 'formik';

import {
  Col,
  Row,
  InputField,
  SwitchField,
  SelectField,
  StatesSelectField,
  AddressAutoCompleteInputField,
} from 'components';

import * as Styles from './styles';
import { FormValues, CustomerShipmentInfoProps } from './types';

export const CustomerShipmentInfo = ({
  customers,
}: CustomerShipmentInfoProps) => {
  const { values, setValues, setFieldValue } = useFormikContext<FormValues>();

  const customerSelectOptions =
    customers?.map((customer) => ({
      value: customer.id,
      label: customer?.person?.name,
    })) ?? [];

  return (
    <Styles.Container>
      <Row>
        <Col>
          <SwitchField
            name="isNewCustomer"
            label="New Customer"
            onChange={async (e) => {
              const checked = (e.target as HTMLInputElement).checked;
              if (checked) {
                setValues((prevValue) => ({
                  ...prevValue,
                  zip: '',
                  city: '',
                  email: '',
                  phone: '',
                  state: '',
                  address: '',
                  countryCode: 'US',
                  recipientId: undefined,
                }));
              } else {
                await setFieldValue('lastName', undefined);
                await setFieldValue('firstName', undefined);
              }
            }}
          />
        </Col>
      </Row>

      <Row>
        {values.isNewCustomer ? (
          <>
            <Col col={3}>
              <InputField name="firstName" label="First name" />
            </Col>
            <Col col={3}>
              <InputField name="lastName" label="Last name" />
            </Col>
          </>
        ) : (
          <Col col={3}>
            <SelectField
              onlyValue
              label="Recipient"
              name="recipientId"
              options={customerSelectOptions}
              onChange={async (option) => {
                if (option && 'value' in option) {
                  const customer = customers?.find(
                    (item) => item.id === option?.value
                  );

                  if (customer) {
                    const { person } = customer;
                    const { zip, city, state, email, phone, address } = person;

                    setValues((prevValue) => ({
                      ...prevValue,
                      zip,
                      city,
                      email,
                      phone,
                      state,
                      address,
                      countryCode: 'US',
                    }));
                  }
                }
              }}
            />
          </Col>
        )}

        <Col col={3}>
          <InputField type="tel" name="phone" label="Phone" />
        </Col>

        <Col col={3}>
          <InputField name="email" label="Email" />
        </Col>

        <Col col={3}>
          <AddressAutoCompleteInputField countryCodeFieldName="countryCode" />
        </Col>

        <Col col={3}>
          <StatesSelectField name="state" />
        </Col>
        <Col col={3}>
          <InputField name="city" label="City" placeholder="Enter city" />
        </Col>
        <Col col={3}>
          <InputField
            name="zip"
            label="Zip code"
            inputMode="numeric"
            autoComplete="postal-code"
            placeholder="Enter zip code"
          />
        </Col>
      </Row>
    </Styles.Container>
  );
};
